export default __webpack_public_path__ + "static/media/drug3.08f4b45c.png";